<div class="image-container content-center">
  <img class="media-image" [ngClass]="{'display-none': !display}" (load)='imageLoaded()' (error)='fallbackImg()' src='' alt="" #imagePlayer>
  <ion-spinner [ngClass]="{'display-none': display}" name="crescent"></ion-spinner>
</div>